import { render, staticRenderFns } from "./Wallpaper.vue?vue&type=template&id=d9e26482"
import script from "./Wallpaper.vue?vue&type=script&lang=js"
export * from "./Wallpaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports